import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-submit',
  templateUrl: './contact-submit.component.html',
  styleUrls: ['./contact-submit.component.sass']
})
export class ContactSubmitComponent implements OnInit {
  public isLoaded = false;

  constructor() { }

  ngOnInit(): void {
    this.checkIframeLoaded();
  }

  checkIframeLoaded() {
    const iframe = document.getElementById("contactUsForm");
    iframe.addEventListener("load", () => {
        this.isLoaded = true;
    });
  }

}
